// extracted by mini-css-extract-plugin
module.exports = {"component":"LanguagePicker_component___8rU0","isOpen":"LanguagePicker_isOpen__HE5wH","dropdown":"LanguagePicker_dropdown__lXLk4","current":"LanguagePicker_current__652_A"};